import React from "react";

const Shared = () => {
  return (
    <>
      <div className="bg-gray-100">
        <div className="px-3 py-5 text-xl bg-white h">Shared History</div>
        <div className="py-3 h-screen">
          {/* <div className="flex justify-center gap-10  p-2 bg-white rounded-lg ">
            <div className="flex-col justify-center ">
              <img
                src="https://m.media-amazon.com/images/I/81-Ka2xryqL._AC_SR350,526_FMwebp_QL65_.jpg"
                alt=""
                className="h-28"
              />
            </div>
            <div className="flex-col gap-5 pt-2">
              <p className="">Making juicers</p>

              <p className="">170% off </p>
              <p>Last Shared : May 13,</p>
              <p> 11:40 AM</p>
            </div>
          </div>
          <div className="py-2">
            <div className="bg-white">
              <Divider />
              <div className="flex justify-center p-4 gap-10">
                <p className="text-blue-800">
                  <ShareOutlinedIcon className="!mr-4" /> Share Again
                </p>
                <div className="border-r-4"></div>
                <p className="text-blue-800"> WhatsApp</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};
export default Shared;
